export default __webpack_public_path__ + "static/media/logo_social.81293f8f.png";